global.$ = global.jQuery = require('jquery');

// import ModuleName from 'module-path';
// let libName = require('library-name');

document.addEventListener("DOMContentLoaded", function(event) {
jQuery(document).ready(function($) {
    // Toggle Menu - Toggle Menu Function
    jQuery('#toggle').click(function() {
        jQuery(this).toggleClass('active');
        jQuery('#navbarNavDropdown').toggleClass('open');
        jQuery('.site-header').toggleClass('header-open-fixed');
        jQuery('html').toggleClass('hidescroll');
    });
    
    // Hamburger Menu - Remove the Hamburger menu Overlay after click
    jQuery('#main-menu li a').click(function() {
        jQuery('#navbarNavDropdown').removeClass('open');
        jQuery('.mobile-logo').removeClass('mobile-logo-light');
        jQuery('#toggle').removeClass('active');
        jQuery('.site-header').removeClass('header-open-fixed');
    });
    //Submenu drop down
    jQuery("#main-menu li.menu-item-has-children").append("<span class='dot-triggle hidden'><i class='fas fa-caret-down'></i></span>");
    jQuery(".dot-triggle").on("click", function(e) {
        e.preventDefault();
        var currentBox = jQuery(this).siblings("#main-menu .sub-menu").toggleClass("menu-active-mobile");
        jQuery("#main-menu .sub-menu.active-team").not(currentBox).removeClass("menu-active-mobile");
        
        var addclassnew = jQuery(this).closest(".dot-triggle").toggleClass("dot-active-mobile");
        jQuery(".dot-triggle.active-team").not(addclassnew).removeClass("dot-active-mobile");
    });

    // Equal height function
    var title = 0;
    jQuery(".equal-height").each(function(){
      if (jQuery(this).height() > title) { title = jQuery(this).height(); }
    });
    jQuery(".equal-height").height(title);

    // on Resize change height
    jQuery(window).resize(function(){
      jQuery(".equal-height").height("");
      var title = 0;
      jQuery(".equal-height").each(function(){
        if (jQuery(this).height() > title) { title = jQuery(this).height(); }
      });
      jQuery(".equal-height").height(title);
    });
      

    // Header - Add Sticky Header Function.
    jQuery(document).on('scroll', function() {
      if (jQuery(document).scrollTop() > 150) {
          jQuery('.site-header').addClass('sticky-header');
      } else {
          jQuery('.site-header').removeClass('sticky-header');
      }
  });

    //Homepage Search Button for ZipCode
    var input = document.getElementById("zipcode");
    if(input)
    {
        input.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {  
           redirect(e);
        }
        });
    }

    jQuery('#search-button-home').on('click', function(e) {
        e.preventDefault(); 
        redirect(e);
    });

    ///Tab jquery
    jQuery('.menu-tab-menu li a').on('click', function(){
        var target = jQuery(this).attr('data-rel');
        // console.log("target", target);
        // if (target == "tab-7") {
        //   window.open("http://tacomama.test/app/uploads/2022/01/TacoMama_OnlineMenu-1.pdf", "_blank");
        // }
        jQuery('.menu-tab-menu li a').removeClass('active');
        jQuery(this).addClass('active');

        jQuery("#"+target).addClass('active').siblings(".tab-main-box").removeClass('active');
        return false;
    });

    // Hero Header Slider
    jQuery('.hero-owl-carousel').owlCarousel({
      loop:true,
      margin:0,
      nav:false,
      dots: false,
      autoWidth:false,
      items:1,
      responsiveClass:true,
      autoplay:true,
      autoplayTimeout:3000
    })

    // Full Width Image Slider
    jQuery('.full-width-image-slider').owlCarousel({
      loop:true,
      margin:0,
      nav:true,
      items:1,
      autoplay:true,
      autoplayTimeout:3000,
      navText: [
        '<i class="fa-solid fa-chevron-left"></i>',
        '<i class="fa-solid fa-chevron-right"></i>'
    ],
    })

    //Accordiun Function
    jQuery('.accordion-title').click(function(e) {
        e.preventDefault();
        var $this = jQuery(this);
        jQuery('.accordion-title').removeClass('open-acc');
        $this.addClass('open-acc');
        if ($this.next().hasClass('show')) {
            $this.next().removeClass('show');
            $this.next().slideUp(350);
            jQuery('.accordion-title').removeClass('open-acc');

        } else {
            $this.parent().parent().find('.according-inner').removeClass('show');
            $this.parent().parent().find('.according-inner').slideUp(350);
            $this.next().toggleClass('show');
            $this.next().slideToggle(350);
        }
    });

    //Accordiun Click to Top Function
    // jQuery( document ).ready( function( $ ) {
    //   var accordionItems = document.querySelectorAll('.accordion-item');
    //   accordionItems.forEach(item => {
    //       item.addEventListener('click', (e)=>{
    //           setTimeout(function(){
    //               let top = e.target.getBoundingClientRect().top + document.documentElement.scrollTop;
    //               window.scroll({
    //                   top: top - 140,
    //                   behavior: 'smooth'
    //               });
    //           }, 350);
    //       });
    //   });
    // });

    //Catering Page JS
    jQuery('.deliver-button .deliver-option').click(function(){
        jQuery(this).parent().find('.deliver-option').removeClass('selected');
        jQuery(this).addClass('selected');
        var deliverOption = jQuery(this).attr('data-option');
        if (deliverOption == 'Pickup') {
          jQuery('.delivery-address-field').addClass('hidden');
          jQuery('.delivery-address-field input').val("Pick Up");
        }
        if (deliverOption == 'Deliver') {
          jQuery('.delivery-address-field').removeClass('hidden');
          jQuery('.delivery-address-field input').val("");
        }
        document.getElementById("deliverOption").value = deliverOption;
       
    });

    jQuery(document).ready(function() {
      jQuery("#datepicker").datepicker({
        minDate: new Date(),
        dateFormat: "mm/dd/yy",	
        duration: "fast"
      });
      
      jQuery('#datepicker').bind('keypress paste keydown', function (event) {
        // if (event.keyCode == 8) {
        //     return false;
        // }
        // if (event.keyCode == 46) {
        //     return false;
        // }
        // return false;
        event.preventDefault();
      });

      jQuery('#datepicker').on('change', function() {
        var selectedDate = jQuery(this).datepicker('getDate');
        var today = new Date();
        today.setHours(0, 0, 0, 0); // Set time to 00:00:00 for accurate comparison

        if (selectedDate < today) {
          jQuery("#invaliddate_error").show();
          jQuery(this).val('');
        }
      });
    });

    ///////Plus minus script
    jQuery(document).ready(function() {
        jQuery('.custom-plus-minus .minus').click(function () {
            var $input = jQuery(this).parent().find('.qty-input');
            var count = parseInt($input.val()) - 1;
            count = count < 1 ? 1 : count;
            $input.val(count);
            $input.change();
            return false;
        });
        jQuery('.custom-plus-minus .plus').click(function () {
            var $input = jQuery(this).parent().find('.qty-input');
            var $another = jQuery(this).find('.qty-input').val();
            var value = jQuery(this).parent().find('.qty-input').val();
            // console.log('input', $input);
            // console.log("valu", value);
            // console.log("another", $another);
            if (!value) {
              $input.val(1);
              $input.change();
            } else {
              $input.val(parseInt($input.val()) + 1);
              $input.change();
            }
            return false;
        });
    });

    ////////////Custom Select 
  
  ///Time Picker JS
  jQuery("#timepicker").datetimepicker({
    format: "LT",
    allowInputToggle: true,
    icons: {
      up: "fa fa-chevron-up",
      down: "fa fa-chevron-down"
    }
  });

  // Wait for the DOM to be ready
  jQuery(function() {
    // jQuery.validator.addClassRules("less-length-validate", {
    //   required: true,
    //   minlength: 1,
    //   maxlength: 2,
    //   number: true
    // });
    jQuery("form[name='catering-form']").validate({
      focusInvalid: false,
      invalidHandler: function(form, validator) {
          // console.log('validator', validator.errorList[0].element.name);
          if (!validator.numberOfInvalids())
              return;

          if (validator.errorList[0].element.name == "locationTitle") {
            $('html, body').animate({
              scrollTop: $('.locations').offset().top-100
           }, 1500);
          } else {
            $('html, body').animate({
              scrollTop: $(validator.errorList[0].element).offset().top-80
            }, 1500);
          }

      },
      ignore: "not:hidden",
      rules: {
        ContactName: "required",
        CateringDate: "required",
        GroupName: "required",
        Phone:{
          required:true,
          minlength:9,
          maxlength:10,
          number: true
        },
        EmailAddress: {
          required: true,
          email: true
        },
        catering_zipcode:{
          required:true,
          minlength:5,
          maxlength:5,
          number: true
        },
        // Amigos:{
        //   required:true,
        //   minlength:2,
        //   maxlength:2,
        //   number: true
        // },
        // Quantity: {
        //   required:true,
        //   minlength:1,
        //   maxlength:2,
        //   number: true
        // },
        //'Amigos[]': "required",
        DeliveryAddress: "required",
        DeliveryTime: "required",
        locationTitle: {
          required :  function(element) {
              return $("#catering_zipcode").is(":filled");
            }
        },
      },
      // Specify validation error messages
      messages: {
          ContactName: "Please enter your contact name",
          CateringDate: "Please enter the catering date",
          Phone: "Please enter your phone number",
          EmailAddress: "Please enter a valid email address",
          DeliveryAddress: "Please enter the delivery address",
          DeliveryTime: "Please enter the delivery time",
          locationTitle: "Please select a location",
          'Amigos[]': "Please select at least 10 amigos",
          'Quantity[]': "Please enter a valid quantity",
          catering_zipcode: "Please enter the zipcode",
          GroupName: "Please enter your group name"
      },
      // submitHandler: function(form) {
      //   console.log("form submitted");
      //   form.submit();
      // }
    });

  // Add event listeners for 'keyup' and 'focusout'
  jQuery("#catering_zipcode").on("keyup focusout", function () {
    // Check if the 'catering_zipcode' field is valid
    if (jQuery("#catering_zipcode").valid()) {
        // Show the hidden button
        jQuery("#search-button-catering").prop("disabled", false);
    } else {
        // Hide the button if the field is not valid
        jQuery("#search-button-catering").prop("disabled", true);
    }
  });

  jQuery('#phone').on('input', function() {
    // Get the phone number input value
    var phoneNumber = $(this).val();
    
    // Remove dashes from the phone number
    var sanitizedPhoneNumber = phoneNumber.replace(/-/g, '');
    
    // Set the sanitized phone number back to the input field
    $(this).val(sanitizedPhoneNumber);
  });

if (jQuery(window).width() < 767) {
  // Video Play/Pause after click
  jQuery('.video-play-btn').click(function() {
    jQuery('.video-header').addClass('videoShowHeader');
    setTimeout(() => {
      jQuery('.video-header').removeClass('videoShowHeader');
      jQuery('.video-header').addClass('videoHideHeader');
    }, 1500);
  });
  // jQuery('.video-push-btn').click(function() {
  //   jQuery('.video-header').removeClass('videoShowHeader');
  // });
  jQuery('.video-header').click(function() {
    jQuery(this).removeClass('videoHideHeader');
  });

  // Video Play/Push button action
  jQuery(document).ready(function() {
    const video = document.getElementById("video");
    const circlePlayButton = document.getElementById("circle-play");
    jQuery('.video-play-btn').addClass('videoShow');
    
    function togglePlay() {
      if (video.paused || video.ended) {
        video.play();
        jQuery('.video-push-btn').addClass('videoShow');
        jQuery('.video-play-btn').removeClass('videoShow');
        // jQuery('#circle-play svg').addClass('mobile-videoShow');
      } else {
        video.pause();
        jQuery('.video-push-btn').removeClass('videoShow');
        jQuery('.video-play-btn').addClass('videoShow');
        // jQuery('#circle-play svg').removeClass('mobile-videoShow');
      }
    }
    circlePlayButton.addEventListener("click", togglePlay);
  });
  // jQuery('.different-video').click(function () {
  //   jQuery('#circle-play svg').toggleClass();
  // });
}
else {
  // Video Play/Push button action
  jQuery(document).ready(function() {
    const video = document.getElementById("video");
    const circlePlayButton = document.getElementById("circle-play");
    jQuery('.video-push-btn').addClass('videoShow');
    
    function togglePlay() {
      if (video.paused || video.ended) {
        video.play();
        jQuery('.video-play-btn').removeClass('videoShow');
        jQuery('.video-push-btn').addClass('videoShow');
        // jQuery('#circle-play svg').addClass('mobile-videoShow');
      } else {
        video.pause();
        jQuery('.video-play-btn').addClass('videoShow');
        jQuery('.video-push-btn').removeClass('videoShow');
        // jQuery('#circle-play svg').removeClass('mobile-videoShow');
      }
    }
    circlePlayButton.addEventListener("click", togglePlay);
  });
}
  
// if(is_ios)    
// {
  
// };

});

});

function redirect(e) {
    var zipcodeVal = document.getElementById("zipcode").value;
    location.href = "/location/?zipcode="+zipcodeVal;
}

});

jQuery('#menu a').html(function(i,html) {
  return html.replace(/\ñ/g, '<svg class="n-char" xmlns="http://www.w3.org/2000/svg" id="Layer_2" viewBox="0 0 38.81 68.77"><g id="Layer_1-2"><path class="cls-1" d="m3.94,23.21h.56c.75,0,1.12.56,1.12,1.69l1.69-1.12c2.25,2,3.38,4.44,3.38,7.31h-.56c.75,1.72,1.12,3.41,1.12,5.06,1.12,0,2.81-2.06,5.06-6.19,3.91-1.5,6.34-2.25,7.31-2.25,7.91,0,12.97,6.94,15.19,20.81v2.81c0,.38-.19.56-.56.56l.56,1.12c0,7.88-.75,11.81-2.25,11.81-1.06,2.62-2,3.94-2.81,3.94h-3.38c-2.25-2-3.38-4.25-3.38-6.75v-14.62c0-3.81-1.5-7-4.5-9.56-4.88,5.78-7.31,12.91-7.31,21.37-.38,0-.56.19-.56.56s.19.56.56.56c0,3.91-1.88,6.72-5.62,8.44h-1.12c-3.75,0-5.62-2.25-5.62-6.75v-3.38c0-.38.19-.56.56-.56C1.88,48.27.75,38.7,0,29.39c0-1.97,1.31-3.66,3.94-5.06v-1.12Z" style="fill: currentColor;"/><path class="cls-1" d="m10.69,0c3.59,0,8.09,2.06,13.5,6.19h2.25l4.5-3.94h.56c1.88,0,3.56,1.12,5.06,3.37-4.56,6.75-8.31,10.12-11.25,10.12-2.53,0-6.47-2.06-11.81-6.19h-3.38c-.22,0-1.34,1.12-3.38,3.38h-2.25c-.97,0-1.72-1.5-2.25-4.5,0-1.97,2.81-4.78,8.44-8.44Z" style="fill: currentColor;"/></g></svg>');
}); 

jQuery('.ninos-title').html(function(i,html) {
  return html.replace(/\ñ/g, '<svg xmlns="http://www.w3.org/2000/svg" id="Layer_2" viewBox="0 0 42.82 91.82"><g id="Layer_1-2"><path class="cls-1" d="m42.82,55.82c0-.32-.13,2.78-.38,9.31-.32,7.94-.63,16.61-.95,26.02-3.23.45-5.82.67-7.78.67-.25,0-.79-.11-1.61-.34-.82-.22-1.39-.34-1.71-.34-.25,0-.62.06-1.09.19-.47.13-.81.19-1,.19-1.39,0-2.09-.54-2.09-1.63v-2.5c.06-1.28.06-2.56,0-3.84-.06-1.28-.93-3.81-2.59-7.58-2.75-6.4-6.3-15.55-10.66-27.46-.71-2.11-1.89-5.54-3.55-10.27-.32-1.34-1.06-3.42-2.21-6.24-.58,1.34-.86,3.07-.86,5.18v11.62c0,.06.19.35.58.86.06,1.92,0,5.03-.19,9.31-.26,4.61-.38,6.75-.38,6.43v16.32c0,.45.1,1.39.29,2.83.19,1.44.29,2.54.29,3.31,0,1.66-.32,2.94-.96,3.84-.19.06-.71.1-1.54.1-.9,0-1.5-.1-1.82-.29l-2.3-1.73v-19.2c0-.19-.06-3.26-.19-9.22-.06-5.76-.1-8.8-.1-9.12,0-2.05.06-4.29.19-6.72.13-2.24.32-5.63.58-10.18.26-2.88.22-6.75-.1-11.62.45-.51,1.11-.77,2.01-.77.64,0,3.12.38,7.46,1.15.51,1.15,1.69,4.1,3.54,8.83,1.15,3.07,2.42,6.43,3.83,10.08,1.4,3.65,2.93,8.03,4.59,13.15,1.34,4.16,2.61,7.55,3.83,10.18.13-.9.22-3.55.29-7.97v-11.81c0-4.54,0-6.72,0-6.53v-16.32c1.22-.7,3.23-1.06,6.05-1.06.19,0,.53.11,1.01.34.48.22.85.34,1.1.34s.9-.06,1.92-.19c1.02-.13,1.66-.19,1.92-.19.77,0,1.54.06,2.3.19.83.51,1.31,1.95,1.44,4.32,0,1.98.03,3.97.1,5.95.51,5.89.77,13.34.77,22.37Z" style="fill: currentColor;"/><path class="cls-1" d="m12.04,0c3.86,0,8.69,2.06,14.5,6.19h2.42l4.83-3.94h.6c2.01,0,3.83,1.12,5.44,3.38-4.9,6.75-8.93,10.12-12.08,10.12-2.72,0-6.93-3.18-12.67-7.3l-3.65,1.12c-.23,0-1.44,1.12-3.63,3.38h-2.42c-1.04,0-1.85-1.5-2.42-4.5,0-1.97,3.02-4.78,9.06-8.44Z" style="fill: currentColor;"/></g></svg>');
}); 